import axiosInstance from '../../../axiosInstance'
import apiEndpoints from '../../../api'


export const getAccountsOpeningListReq = (action) => {
    const params = { ...action?.data } || {};
    delete params.onSuccess;
    return axiosInstance.get(apiEndpoints.GET_ACCOUNTS_OPENING_LIST_API, { params });
}

export const createAccountsOpeningReq = (action) => {
    const payload = { ...action?.data } || {};
    delete payload.onSuccess;
    return axiosInstance.post(apiEndpoints.CREATE_ACCOUNTS_OPENING_API, payload);
}

export const updateAccountsOpeningReq = (action) => {
    const { id, onSuccess, ...payload } = action?.data || {};
    const url = apiEndpoints.UPDATE_ACCOUNTS_OPENING_API.replace(':id', id);
    return axiosInstance.put(url, payload);
}

export const deleteAccountsOpeningReq = (action) => {
    const { id } = action?.data || {};
    const url = apiEndpoints.DELETE_ACCOUNTS_OPENING_API.replace(':id', id);
    return axiosInstance.delete(url);
}

export const downloadAccountsOpeningReq = (action) => {
    const params = { ...action?.data } || {};
    return axiosInstance.get(apiEndpoints.DOWNLOAD_ACCOUNTS_OPENING_API, { params, responseType: 'blob' });
}

export const bulkUploadAccountsOpeningReq = (action) => {
    const { file, society_id } = action?.data || {};
    const formData = new FormData();
    formData.append('file', file);
    formData.append('society_id', society_id);
    return axiosInstance.post(apiEndpoints.BULK_UPLOAD_ACCOUNTS_OPENING_API, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
}

export const getGlAccountsOpeningReq = (action) => {
    const { societyId, ...params } = action?.data || {};
    const url = apiEndpoints.GET_GL_ACCOUNTS_OPENING_API.replace(':societyId', societyId);
    return axiosInstance.get(url, { params });
}

export const saveGlAccountsOpeningReq = (action) => {
    const { societyId, onSuccess, ...payload } = action?.data || {};
    const url = apiEndpoints.SAVE_GL_ACCOUNTS_OPENING_API.replace(':societyId', societyId);
    return axiosInstance.post(url, payload);
}
